/**
 * Drawer component for displaying product option details.
 * @extends Drawer
 */
class ProductOptionDrawer extends Drawer {
  constructor() {
    super();
  }

  /**
   * Opens the drawer and sets its content.
   * @param {HTMLElement} triggeredBy
   */
  open(triggeredBy) {
    super.open(triggeredBy);

    this.setContent(triggeredBy);
  }

  /**
   * Sets the drawer content based on the triggering element.
   * @param {HTMLElement} element
   */
  setContent(element) {
    const drawerImage = element.dataset.drawerImage;
    const drawerTitle = element.dataset.drawerTitle;
    const drawerContent = element.dataset.drawerContent;

    this.heading.textContent = drawerTitle;
    this.content.innerHTML = drawerContent;
    this.image.innerHTML = `
      <img
        src="${drawerImage}"
        alt="${drawerTitle}"
        class="product-option-drawer__image"
        loading="lazy"
        height="100%"
        width="100%"
      />
    `;
  }

  /**
   * Returns the drawer image container element.
   * @returns {HTMLElement}
   */
  get image() {
    return this.querySelector("[data-drawer-image]");
  }

  /**
   * Returns the drawer heading element.
   * @returns {HTMLElement}
   */
  get heading() {
    return this.querySelector("[data-drawer-heading]");
  }

  /**
   * Returns the drawer content element.
   * @returns {HTMLElement}
   */
  get content() {
    return this.querySelector("[data-drawer-content]");
  }
}

if (!customElements.get('product-option-drawer')) {
  customElements.define('product-option-drawer', ProductOptionDrawer);
}